import { createFileRoute } from '@tanstack/react-router'
import ContactsGridSearch from 'Contact/components/Contact/search/ContactsGridSearch'
import { claimTypesEnum } from 'User/utils/claims'
import { Suspense } from 'react'

import { PageSkeleton } from 'Common/components/skeletons'

import { Guard } from '../-guard'

export const Route = createFileRoute('/contacts/')({
    validateSearch: (search: Record<string, string>) => search,
    component: () => (
        <Guard claims={[claimTypesEnum.enum.opus_contacts]}>
            <Suspense fallback={<PageSkeleton variant="grid" wrapper="page" />}>
                <ContactsGridSearch />
            </Suspense>
        </Guard>
    ),
})
